let hasBeenClickedBefore: boolean = false;
let listingsSection: HTMLElement;
export default async function handleShowSimilarAdsPopup(id: string) {
    listingsSection = document.querySelector('#listings')!
    const isDesktop = existsDataProperty("data-device", "desktop");
    const similarModal = document.getElementById('similar-modal');
    const shouldShowSimilarsPopup = !hasBeenClickedBefore && isDesktop && similarModal;

    if (shouldShowSimilarsPopup) {
        const response = await getHtmlForSimilarAdsPopup(id, 6);
        if (response.status == 200) {
            similarModal.innerHTML = await response.text();
            similarModal.style.display = 'block';
            registerSimilarAdsPopupEvents();
            hasBeenClickedBefore = true;
        }
    }
}

function existsDataProperty(property: string, value: string) {
    return document.querySelector(`div[${property}=${value}]`);
}

function registerSimilarAdsPopupEvents ()  {
    const closeIcon = document.getElementById("similar-modal__wrapper__header__close");
    const closeButton = document.getElementById("similar-modal__wrapper__footer__close");
    if (closeIcon && closeButton) {
        registerSimilarAdsPopupCloseEvents([closeIcon, closeButton]);
    }
}

function registerSimilarAdsPopupCloseEvents(elements: HTMLElement[]) {
    elements.map(element => element.addEventListener('click', hideSimilarAdsPopup));
}

function hideSimilarAdsPopup() {
    const modalWrapper = document.getElementById('similar-modal');
    if (modalWrapper) {
        modalWrapper.style.display = 'none';
    }
}

async function getHtmlForSimilarAdsPopup(id: string, numberOfAds: number) {
    const paramQ = listingsSection.dataset.searchquery!;
    const pageViewId = listingsSection.dataset.pvid!;
    const paramTracking = listingsSection.dataset.tracking!;
    const ids = Array.from(document.querySelectorAll('[data-idanuncio]')).map(e => e.getAttribute('data-idanuncio'))
    const idsParam = ids == null ? '' : ids.join(',')

    return await fetch(`/internal/mitula/serp/similar-modal?id=${id}&number=${numberOfAds}&q=${paramQ}&ids=${idsParam}&currentOrigin=${paramTracking}&pageViewId=${pageViewId}`, {
        method: 'GET',
    });
}
